var map = {
	"./icon-bg-phone.png": "c24d",
	"./icon-circle-phone.png": "b243",
	"./icon-doc.png": "6cf9",
	"./icon-docx.png": "e1e4",
	"./icon-folder.png": "bf8b",
	"./icon-jpg.png": "749a",
	"./icon-m4a.png": "dc8e",
	"./icon-mp3.png": "7d50",
	"./icon-mp4.png": "54aa",
	"./icon-msg.png": "68f6",
	"./icon-msg4.png": "9c8c",
	"./icon-other.png": "7eae",
	"./icon-pdf.png": "a7c6",
	"./icon-png.png": "6cc4",
	"./icon-ppt.png": "75e7",
	"./icon-pptx.png": "1bf9",
	"./icon-psd.png": "4630",
	"./icon-rar.png": "6690",
	"./icon-screen.png": "e768",
	"./icon-txt.png": "cc73",
	"./icon-voice.png": "3cb3",
	"./icon-weapp.png": "1c50",
	"./icon-weixin-big.png": "8eb2",
	"./icon-xls.png": "6e1b",
	"./icon-xlsx.png": "096f",
	"./icon-zip.png": "812f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e962";